const yup = require("yup");

const editReceiptDetailsValidationSchema = yup.object({
  companyName: yup.string().required("This field is required"),
  amount: yup
    .number()
    .typeError("Amount must be a number")
    .positive("Amount must be greater than 0")
    .required("This field is required"),
  transactionDate: yup
    .mixed()
    .nullable()
    .test("required", "This field is required", (value) => value != null),
});

module.exports = {
  editReceiptDetailsValidationSchema,
};
